// Share payloads for the game-detail screen's social share buttons.
//
// Pure builders: given the session user and the game-detail API response
// pieces, return an openShareMenu() payload (src/client/modules/social-share.js)
// or null when the button must not be offered. Null encodes the entry-point
// contract: signed-in user's OWN accomplishments only — an unlocked
// achievement of the viewer, or the viewer's high score with a live rank
// (rank is only present when the game supports scores; the server re-verifies
// every fact before rendering a card either way).

export function achievementSharePayload(user, game, ach) {
  if (!user?.username) return null;
  if (!ach?.unlocked || !ach.slug || game?.id == null) return null;
  return {
    kind: 'achievement',
    username: user.username,
    gameId: game.id,
    achSlug: ach.slug,
    name: ach.name,
    points: ach.points || 0,
    gameTitle: game.title || 'this game',
    rarityPercent: ach.rarity_percent ?? null,
    rarityTier: ach.rarity_tier ?? null,
  };
}

export function scoreSharePayload(user, game, userStats) {
  if (!user?.username) return null;
  if (game?.id == null || userStats?.high_score == null || userStats.rank == null) return null;
  return {
    kind: 'score',
    username: user.username,
    gameId: game.id,
    rank: userStats.rank,
    score: userStats.high_score,
    gameTitle: game.title || `Game #${game.id}`,
  };
}
